import { LexerEvent } from "../../text/lexer/LexerEvent";
import { ParserPhase } from "../../text/lexer/parsing/ParserPhase";
import { PrecedenceLevel } from "../operators/PrecedenceLevel";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { Operator } from "../operators/Operator";
import { RJLexer } from "../RJLexer";
import { RJParser } from "../RJParser";

export abstract class RJOperatorsProcessor extends ParserPhase<RJParser>
{

  precedenceLevels: PrecedenceLevel[] = []
  operators:  Operator[] = [];



  processExpressions( expressions:RJExpressionNode[] )
  {
    for ( let i = 0; i < this.precedenceLevels.length; i++ )
    {           
      var changed = this.precedenceLevels[ i ].process( expressions ); 

      if ( this.parser.hasErrors )
      {
        return;
      }

      if ( changed )
      {
        i = -1;
      }
    }   
  }

  
  addPrecedenceLevel( ...operators:Operator[] )
  {
    var level = new PrecedenceLevel();
    level.operators = level.operators.concat( operators );

    operators.forEach(
      op => 
      {
        if ( ! op.isFromLeft() )
        {
          level.fromLeft = false;
        }
      }
    )

    this.operators = this.operators.concat( operators );

    this.precedenceLevels.push( level );

    this.operators.forEach( op => op.setProcessor( this ) );
  }
}